module.exports = __webpack_public_path__ + "img/team-logo.8c2a4703.jpg";